class MProductVas extends HTMLElement {
  constructor() {
    super();
    if (this.hasChildNodes()) this.init();

    this.showPrintingArea = true;
    this.toggleBtnStructure = `
      <div class="teeinblue-print-area-toggle">
        <input
          type="checkbox"
          class="switch"
          id="{areaID}"
          checked
        >
        <label for="{areaID}">${window.theme.strings.vas.showPrintingLabel}</label>
      </div>
    `;
    this.colorNoticeStructure = `
      <div class="teeinblue-modal-color-notice">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect width="24" height="24" rx="12" fill="#1A66D2"/>
          <path d="M13.0234 9.53125V17.9844H11.1328V9.53125H13.0234ZM11 7C11 6.71354 11.0938 6.47656 11.2812 6.28906C11.474 6.09635 11.7396 6 12.0781 6C12.4115 6 12.6745 6.09635 12.8672 6.28906C13.0599 6.47656 13.1562 6.71354 13.1562 7C13.1562 7.28125 13.0599 7.51562 12.8672 7.70312C12.6745 7.89062 12.4115 7.98438 12.0781 7.98438C11.7396 7.98438 11.474 7.89062 11.2812 7.70312C11.0938 7.51562 11 7.28125 11 7Z" fill="white"/>
        </svg>
        <p>${window.theme.strings.vas.colorNotice}</p>
      </div>
    `;
    this.printTypeNotice = `
      <div class="tee-upload-instruction">
       ${window.theme.strings.vas.printTypeNotice}
      </div>
    `;
    this.samePrintSides = [];
  }

  static async sleep(time) {
    await new Promise((resolve) => setTimeout(resolve, time));
  }

  init() {
    this.form = this.querySelector('.js-product-form');
    this.variantPicker = document.querySelector('.product-options variant-picker');
    this.priceElem = document.querySelector('.product .product-price .price__default .price__current');
    this.formColorNotification = document.querySelector('.m-js-form-color-notification');
    this.printCombinationsSelects = this.querySelectorAll('.m-js-print-combinations-wrapper');
    this.currentVariantId = this.dataset.initialVariantId;
    if (this.form) {
      this.isTeeLoaded();
    }
  }

  isTeeLoaded() {
    const teeObserver = new MutationObserver(() => {
      this.teeFormWrapper = this.querySelector('#tee-artwork-form');
      this.teeFormInputs = this.querySelector('#tee-artwork-form #teeFormInputs');
      this.addToCartBtn = this.querySelector('.product-info__add-button button');

      if (this.teeFormInputs) {
        teeObserver.disconnect();
        setTimeout(() => {
          this.initVariantChangeListener();
          this.initVasAddToCartListener();
          this.repositionFormColorNotification();
          this.insertHeading();
          this.insertFormToggle();
          this.insertPrintCombinationsSelects();
          this.printAreaListener();
          this.isTeeModalRendered();
          this.showTemplateNames();
          this.initTypeListener();
          this.updateSideOptionsHeadings();
          this.initialPrintAreaSetUp();
          this.initEnableSideOptionsListener();
        }, 1000);
      }
    });

    teeObserver.observe(this.form, { childList: true, subtree: true });
  }

  isTeeModalRendered() {
    this.teeProductModal = document.querySelector('.tee-shopify-product.teeinblue-item.teeinblue-item--product');

    const teeModalObserver = new MutationObserver(() => {
      this.productMockupEl = this.teeProductModal.querySelector('.tee-dialog-product-mockup');
      this.imageRepositionModal = this.teeProductModal.querySelector('.tee-dialog-image-placement');

      if (this.productMockupEl) {
        this.insertModalToggle();
        this.initialPrintAreaSetUp();
      }

      if (this.imageRepositionModal) {
        this.insertColorNotice();
        this.initialPrintAreaSetUp();
      }
    });

    teeModalObserver.observe(this.teeProductModal, { childList: true, subtree: true });
  }

  repositionFormColorNotification() {
    const notification = this.formColorNotification.cloneNode(true);

    this.formColorNotification.remove();
    this.teeFormWrapper.insertAdjacentHTML('afterend', notification.outerHTML);
  }

  insertHeading() {
    const headingText = window.theme.strings.vas.heading;
    this.headingElement = document.createElement('p');
    this.headingElement.classList.add('h5', 'tee-form-heading');
    this.headingElement.innerHTML = headingText;

    this.teeFormInputs.insertAdjacentElement('afterbegin', this.headingElement);
  }

  insertFormToggle() {
    this.headingElement?.insertAdjacentHTML(
      'afterend',
      this.toggleBtnStructure.replaceAll('{areaID}', 'togglePrintAreaForm'),
    );
    this.querySelector('#togglePrintAreaForm')?.addEventListener('change', this.printAreaEventHandler.bind(this));
  }

  insertPrintCombinationsSelects() {
    this.printItemsObj = JSON.parse(this.querySelector('#printItemsProducts').innerHTML);
    this.printCombinationsSelects.forEach((select) => {
      this.headingElement?.insertAdjacentHTML(
        'afterend',
        select.outerHTML.replace('tw-hidden', 'm-js-combination-select-added'),
      );
    });
    this.addedPrintCombinationsSelects = document.querySelectorAll('.m-js-combination-select-added');

    this.initPrintCombinationsSelectListener();
    this.initPrintCombinationsModalOpenListener();
    this.updatePrintCombinationsSelectsVisibility();
    this.updatePrintCombinationsModalPosition();
    this.initPrintCombinationsModalCloseListener();
  }

  initPrintCombinationsModalOpenListener() {
    const printCombinationsOpenModalBtns = document.querySelectorAll(
      '.m-js-combination-select-added .m-js-open-combinations-modal',
    );

    printCombinationsOpenModalBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const parentSelect = e.target.closest('.m-js-print-combinations-wrapper');
        const selectedVariant = parentSelect.dataset.variantId;
        const exactModal = document.querySelector(
          `.m-js-print-combinations-modal[data-variant-id="${selectedVariant}"]`,
        );
        exactModal.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  initPrintCombinationsModalCloseListener() {
    const printCombinationsCloseModalBtns = document.querySelectorAll('.m-js-close-combinations-modal');

    printCombinationsCloseModalBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const parentWrapper = e.target.closest('.m-js-print-combinations-modal');
        parentWrapper.classList.remove('is-visible');
        document.body.style.overflow = 'auto';
      });
    });
  }

  updatePrintCombinationsSelectsVisibility() {
    const currentVariantId = +this.form.querySelector('[name="id"]').value;

    this.teeFormInputs.querySelectorAll('.m-js-print-combinations-wrapper').forEach((select) => {
      const selectId = +select.dataset.variantId;

      if (selectId === currentVariantId) {
        select.style.display = 'block';
        const selectElement = select.querySelector('select');
        const sideCombinationCode = selectElement.options[selectElement.selectedIndex].dataset.combinationCode;

        this.updateSideOptions(sideCombinationCode);
      } else {
        select.style.display = 'none';
      }
    });

    this.updateProductPrice();
  }

  updatePrintCombinationsModalPosition() {
    const printCombinationsModals = document.querySelectorAll('.m-js-print-combinations-modal');
    printCombinationsModals.forEach((modal) => document.body.appendChild(modal));
  }

  updateSideOptions(sideCombinationCode) {
    this.sideCombinationCode = sideCombinationCode;
    const sideOptions = this.querySelectorAll('.m-custom-side-title');

    if (sideOptions) {
      sideOptions.forEach((option) => {
        const optionCode = option.className.match(/m-js-side-([A-Z](?:-[A-Z])*)/)[1].replaceAll('-', '+');
        const optionButtons = option.querySelectorAll('.tee-radio label');

        if (sideCombinationCode.includes(optionCode)) {
          optionButtons.forEach((btn) => btn.textContent === 'true' && btn.click());
        } else {
          optionButtons.forEach((btn) => btn.textContent === 'false' && btn.click());
        }

        if (
          option.classList.contains('m-js-different-print-possible') &&
          option.nextElementSibling?.classList.contains('m-js-same-print')
        ) {
          const samePrintOption =
            option.nextElementSibling?.classList.contains('m-js-same-print') && option.nextElementSibling;

          this.updateSamePrintToggles(samePrintOption);

          if (!samePrintOption.hasAttribute('data-change-listener-added')) {
            samePrintOption.addEventListener(
              'change',
              function (event) {
                const enablePrint = JSON.parse(event.target.dataset.samePrint);

                if (enablePrint) {
                  if (!this.samePrintSides.includes(optionCode)) {
                    this.samePrintSides.push(optionCode);
                  }
                } else {
                  const index = this.samePrintSides.indexOf(optionCode);

                  if (index !== -1) {
                    this.samePrintSides.splice(index, 1);
                  }
                }

                this.initTypeListener();
              }.bind(this),
            );
            samePrintOption.setAttribute('data-change-listener-added', '');
          }
        }

        if (sideCombinationCode.includes(optionCode)) {
          option.style.display = 'block';
        } else {
          option.style.display = 'none';
        }
      });
    }
  }

  insertModalToggle() {
    const toggleAdded = this.productMockupEl?.querySelector('#togglePrintAreaModal');
    const modalFooter = this.productMockupEl?.querySelector('.tee-dcontent-footer');

    if (!toggleAdded && modalFooter) {
      let toggleLayout = this.toggleBtnStructure.replaceAll('{areaID}', 'togglePrintAreaModal');

      if (!this.showPrintingArea) {
        toggleLayout = toggleLayout.replace('checked', '');
      }

      const toggleWrapperLayout = `
        <div>
          ${toggleLayout}
          ${this.colorNoticeStructure}
        </div>
      `;

      modalFooter.insertAdjacentHTML('afterbegin', toggleWrapperLayout);
      modalFooter
        .querySelector('#togglePrintAreaModal')
        ?.addEventListener('change', this.printAreaEventHandler.bind(this));
    }
  }

  insertColorNotice() {
    const modalFooter = this.imageRepositionModal?.querySelector('.tee-dcontent-footer');
    const noticeAdded = this.imageRepositionModal?.querySelector('.teeinblue-modal-color-notice');

    if (!noticeAdded && modalFooter) {
      modalFooter.insertAdjacentHTML('afterbegin', this.colorNoticeStructure);
    }
  }

  async initialPrintAreaSetUp() {
    await this.constructor.sleep(10);

    const printingAreas = document.querySelectorAll('.tee-printarea-wrapper:not(.tee-printarea-wrapper--image)');

    if (!printingAreas.length) {
      this.initialPrintAreaSetUp();
    } else {
      if (this.showPrintingArea) {
        printingAreas?.forEach((area) => {
          area.classList.add('show-area');
        });
      } else {
        printingAreas?.forEach((area) => {
          area.classList.remove('show-area');
        });
      }
    }
  }

  printAreaListener() {
    document.addEventListener('print-area-state-changed', () => {
      const printingAreas = document.querySelectorAll('.tee-printarea-wrapper');
      const formOptionsToggle = this.querySelector('#togglePrintAreaForm');

      if (this.showPrintingArea) {
        printingAreas?.forEach((area) => {
          area.classList.add('show-area');
        });

        // update formOptions toggle
        if (formOptionsToggle) {
          formOptionsToggle.checked = true;
        }
      } else {
        printingAreas?.forEach((area) => {
          area.classList.remove('show-area');
        });

        // update formOptions toggle
        if (formOptionsToggle) {
          formOptionsToggle.checked = false;
        }
      }
    });
  }

  printAreaEventHandler() {
    this.showPrintingArea = !this.showPrintingArea;
    document.dispatchEvent(new Event('print-area-state-changed'));
  }

  showTemplateNames() {
    const templateNameElements = this.querySelectorAll('.tee-field--template');

    templateNameElements.forEach((elem, index) => {
      const elemLabelText = elem.querySelector('span:not(.tee-asterisk):not(.tee-required-message)');
      elemLabelText.innerHTML = elemLabelText.innerHTML.replace('template', '');

      elem.classList.remove('sr-only');
      if (index === 0) {
        elem.style.borderTop = 'none';
        elem.style.paddingTop = '0';
      }
    });
  }

  updateSamePrintToggles(option) {
    const samePrintRadioBtns = option.querySelectorAll('.tee-radio');

    samePrintRadioBtns.forEach((radioBtn) => {
      const radioInput = radioBtn.querySelector('input');
      const radioLabel = radioBtn.querySelector('label');
      if (radioLabel.innerText.includes('[')) {
        const radioAttr = radioLabel.innerText.match(/\[(.*?)\]/)[1];
        const radioLabelText = radioLabel.innerText.replace(/\s*\[.*?\]/, '');

        if (radioLabelText) {
          radioLabel.innerText = radioLabelText;
        }

        if (radioAttr && radioInput) {
          radioInput.setAttribute('data-same-print', radioAttr);
        }
      }
    });
  }

  initPrintCombinationsSelectListener() {
    this.addedPrintCombinationsSelects.forEach((select) => {
      select.addEventListener(
        'change',
        function (event) {
          const sideCombinationCode = event.target.options[event.target.selectedIndex].dataset.combinationCode;

          this.updateSideOptions(sideCombinationCode);
          this.updateProductPrice();
        }.bind(this),
      );
    });
  }

  updateProductPrice() {
    const addedQuantity = +this.querySelector('.qty-input [name="quantity"]').value;
    const variantPickerScript = document.querySelector(
      '.product-options variant-picker script[type="application/json"]',
    );
    const variantsArray = JSON.parse(variantPickerScript.innerHTML).product.variants;
    const currentVariant = variantsArray?.find((variant) => +variant.id === +this.currentVariantId);

    let productPrice = currentVariant.price * addedQuantity;

    const startCostProduct = this.printItemsObj.startCostProduct?.variants[0];
    if (startCostProduct) {
      productPrice += startCostProduct.price;
    }

    const sides = this.sideCombinationCode.split('+');
    const sideLayoutProducts = this.printItemsObj.sideLayoutProducts?.reduce((acc, product) => {
      let count = product.printCombinations?.reduce((total, print) => {
        return total + sides?.filter((side) => side === print && !this.samePrintSides.includes(side)).length;
      }, 0);

      count = Math.min(count, product.maxAmount);

      if (count > 0) {
        acc.push({
          ...product,
          quantity: count,
        });
      }
      return acc;
    }, []);
    if (sideLayoutProducts) {
      sideLayoutProducts.forEach((product) => {
        productPrice += product.price * product.quantity;
      });
    }

    const printCombinationProduct = this.printItemsObj.combinationProducts?.find((product) => {
      return product.printCombinations.includes(this.sideCombinationCode);
    });
    if (printCombinationProduct) {
      productPrice += printCombinationProduct.price * addedQuantity;
    }

    productPrice = productPrice / 100 / addedQuantity;

    this.priceElem.innerHTML = window.theme.settings.moneyFormat
      .replace(/\{\{\s*(\w+)\s*\}\}/, productPrice.toFixed(2))
      .replace('.', ',');
  }

  initEnableSideOptionsListener() {
    const enableSideOptions = document.querySelectorAll('.m-js-enable-print');

    enableSideOptions.forEach((sideOption) => {
      sideOption.addEventListener(
        'change',
        function () {
          setTimeout(() => {
            this.updateSideOptionsHeadings();
            this.initTypeListener();
          }, 100);
        }.bind(this),
      );
    });
  }

  initTypeListener() {
    this.updateSideOptionsHeadings();
    const typeListeners = document.querySelectorAll('.m-js-type-option');

    typeListeners.forEach((typeOption) => {
      const printTypeNoticeAdded = typeOption.querySelector('.tee-upload-instruction');

      if (!printTypeNoticeAdded) {
        typeOption.insertAdjacentHTML('beforeend', this.printTypeNotice);
      }

      typeOption.addEventListener(
        'change',
        function () {
          this.updateSideOptionsHeadings();
        }.bind(this),
      );
    });
  }

  updateSideOptionsHeadings() {
    const sideOptions = document.querySelectorAll('.m-js-content-option');

    sideOptions.forEach((sideOption) => {
      const optionLabel = sideOption.querySelector('label span:not(.tee-asterisk)');
      optionLabel.innerText = optionLabel.innerText.split('{')[0].replace(' ', '');
    });

    this.updatePrintCombinationsSelectsVisibility();
  }

  initVariantChangeListener() {
    document.addEventListener('on:variant:change', (event) => {
      this.currentVariantId = event.detail.variant.id;

      setTimeout(
        function () {
          this.initTypeListener();
          document.dispatchEvent(new Event('print-area-state-changed'));
        }.bind(this),
        100,
      );
    });
  }

  initVasAddToCartListener() {
    document.addEventListener('on:cart:add', async (event) => {
      const customizationID = event.target.querySelector('#tee-customization-id').value;
      const addedVariantID = +event.detail.variantId;
      const variantPickerScript = document.querySelector(
        '.product-options variant-picker script[type="application/json"]',
      );
      const variantsArray = JSON.parse(variantPickerScript.innerHTML).product.variants;
      const variantSKU = variantsArray?.find((variant) => +variant.id === addedVariantID)?.sku;
      const startCostID = this.printItemsObj.startCostProduct?.variants[0].id;
      const sides = this.sideCombinationCode.split('+');
      const buttonCardDrawer = this.querySelector('button[name="add"]');
      if (buttonCardDrawer) {
        buttonCardDrawer.disabled = true;
      }

      const sideLayoutProducts = this.printItemsObj.sideLayoutProducts?.reduce((acc, product) => {
        let count = product.printCombinations?.reduce((total, print) => {
          return total + sides?.filter((side) => side === print && !this.samePrintSides.includes(side)).length;
        }, 0);

        count = Math.min(count, product.maxAmount);

        if (count > 0) {
          acc.push({
            id: product.variantId,
            quantity: count,
            properties: {
              _vas_reference: customizationID,
              _vas_sku: variantSKU,
            },
          });
        }
        return acc;
      }, []);

      const printCombinationProduct = this.printItemsObj.combinationProducts?.find((product) => {
        return product.printCombinations.includes(this.sideCombinationCode);
      });

      const addedQuantity = +this.querySelector('.qty-input [name="quantity"]').value;

      const formData = {
        items: [
          {
            // print combination product
            id: printCombinationProduct.variantId,
            quantity: addedQuantity,
            properties: {
              _vas_reference: customizationID,
              _vas_sku: variantSKU,
              _combination_product: 'true',
            },
          },
          ...sideLayoutProducts, //side layout products
          startCostID && {
            // start cost product
            id: startCostID,
            quantity: 1,
            properties: {
              _vas_reference: customizationID,
              _vas_sku: variantSKU,
            },
          },
        ],
      };

      try {
        const cartResponse = await fetch(`${window.theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        if (!cartResponse.ok) {
          throw new Error(cartResponse.status);
        }

        const cartData = await cartResponse.json();

        if (cartData) {
          document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:refresh', {
              bubbles: true,
            }),
          );

          document.dispatchEvent(new CustomEvent('dispatch:cart-print-items:check'));
        }
      } catch (error) {
        console.error('Error:', error);
      }

      if (buttonCardDrawer) {
        buttonCardDrawer.disabled = false;
      }
    });

    document.addEventListener('on:line-item:change', async (event) => {
      const vasItemChange = event.detail.vasItemCartChange;
      const customizationId = event.detail.customizationId;

      if (!vasItemChange && customizationId) {
        const customizationID = event.target.querySelector('#tee-customization-id')?.value;
        const addedVariantID = +event.detail.variantId;
        const variantPickerScript = document.querySelector(
          '.product-options variant-picker script[type="application/json"]',
        );
        const variantsArray = JSON.parse(variantPickerScript.innerHTML).product.variants;
        const variantSKU = variantsArray?.find((variant) => +variant.id === addedVariantID)?.sku;
        const startCostID = this.printItemsObj.startCostProduct?.variants[0].id;
        const sides = this.sideCombinationCode.split('+');
        const buttonCardDrawer = this.querySelector('button[name="add"]');
        if (buttonCardDrawer) {
          buttonCardDrawer.disabled = true;
        }

        const sideLayoutProducts = this.printItemsObj.sideLayoutProducts?.reduce((acc, product) => {
          let count = product.printCombinations?.reduce((total, print) => {
            return total + sides?.filter((side) => side === print && !this.samePrintSides.includes(side)).length;
          }, 0);

          count = Math.min(count, product.maxAmount);

          if (count > 0) {
            acc.push({
              id: product.variantId,
              quantity: count,
              properties: {
                _vas_reference: customizationID,
                _vas_sku: variantSKU,
              },
            });
          }
          return acc;
        }, []);

        const printCombinationProduct = this.printItemsObj.combinationProducts?.find((product) => {
          return product.printCombinations.includes(this.sideCombinationCode);
        });

        const addedQuantity = +this.querySelector('.qty-input [name="quantity"]').value;

        const formData = {
          items: [
            {
              // print combination product
              id: printCombinationProduct.variantId,
              quantity: addedQuantity,
              properties: {
                _vas_reference: customizationID,
                _vas_sku: variantSKU,
                _combination_product: 'true',
              },
            },
            ...sideLayoutProducts, //side layout products
            startCostID && {
              // start cost product
              id: startCostID,
              quantity: 1,
              properties: {
                _vas_reference: customizationID,
                _vas_sku: variantSKU,
              },
            },
          ],
        };

        try {
          const cartResponse = await fetch(`${window.theme.routes.cartAdd}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          });

          if (!cartResponse.ok) {
            throw new Error(cartResponse.status);
          }

          const cartData = await cartResponse.json();

          if (cartData) {
            document.dispatchEvent(
              new CustomEvent('dispatch:cart-drawer:refresh', {
                bubbles: true,
              }),
            );

            document.dispatchEvent(new CustomEvent('dispatch:cart-print-items:check'));
          }
        } catch (error) {
          if (buttonCardDrawer) {
            buttonCardDrawer.disabled = false;
          }
          console.error('Error:', error);
        }
      }
    });
  }
}

customElements.define('m-product-vas', MProductVas);
